import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

export enum NumberType {
    CHINESE,
    ARABIC,
}

export interface TextRes {
    textIndex: number;
    type: NumberType;
    length: number;
}

export interface RunRes {
    runRes: TextRes[];
    runIndex: number;
}

export interface ParaRes {
    paraRes: RunRes[];
    paraIndex: number;
}

export interface ModelRes {
    modelRes: ParaRes[] | ModelRes[];
    model: IBaseModel;
}

/**
 * 脱敏管理器
 */
export interface INumberTestManager {
    result: ModelRes[];
    /**
     * 替换敏感信息
     * @param keepUnit 是否保留单位
     */
    replaceSensitiveData(slideList: ISlideModel[], keepUnit?: boolean);
}
